import { render } from "./Galeria.vue?vue&type=template&id=5b990a5e&scoped=true"
import script from "./Galeria.vue?vue&type=script&lang=js"
export * from "./Galeria.vue?vue&type=script&lang=js"

import "./Galeria.vue?vue&type=style&index=0&id=5b990a5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b990a5e"]])

export default __exports__